import { jsx } from '@emotion/react';
import React from 'react';
import Toggle from '../../../../Forms/Toggle';

const RewardCtaFields = ({ allRewards = [], rewardIds = [], setFieldValue }) => (
    <>
      {allRewards.map((cta) => (
        <div key={cta.integratedRewardId} style={{ marginBottom: 15 }}>
          <Toggle
            label={cta.rewardName}
            checked={rewardIds?.includes(cta.integratedRewardId)}
            onChange={(_, checked) => {
              const id = cta.integratedRewardId;
              if (checked) {
                setFieldValue("rewardIds", [
                  ...(rewardIds || []),
                  id
                ]);
              } else {
                setFieldValue(
                  "rewardIds",
                  (rewardIds || []).filter(x => x !== id)
                );
              }
            }}
            onText="Include CTA on page"
            offText="Remove CTA from page"
          />
        </div>
      ))}
    </>
  );

export default RewardCtaFields;
